// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"index-module--videoContainer--1ozBj","video":"index-module--video--3tNF2"};